import { DeviceSoftwareEndOfSupportInput } from '@totem/components/devices/softwareEndOfLife/summary/types';
import { Filter, Params } from '@totem/types/common';
import { isNotNull } from '@totem/utilities/common';

export const buildSummaryFilters = (input: DeviceSoftwareEndOfSupportInput) => {
  const paramFilters: Filter[] = [];

  if (isNotNull(input.regionId) && input.regionId.length > 0) {
    paramFilters.push({
      field: 'regionId',
      values: input.regionId,
    });
  }
  if (isNotNull(input.buildingId) && input.buildingId.length > 0) {
    paramFilters.push({
      field: 'buildingId',
      values: input.buildingId,
    });
  }
  if (isNotNull(input.controlSystemId) && input.controlSystemId.length > 0) {
    paramFilters.push({
      field: 'controlSystemId',
      values: input.controlSystemId,
    });
  }
  if (isNotNull(input.deviceId) && input.deviceId.length > 0) {
    paramFilters.push({
      field: '_id',
      values: input.deviceId,
    });
  }
  if (isNotNull(input.tags) && input.tags.length > 0) {
    paramFilters.push({
      field: 'softwareTags',
      values: input.tags,
    });
  }

  return paramFilters;
};

export const buildParameters = (input: DeviceSoftwareEndOfSupportInput) => {
  const params: Params = {
    paging: {
      page: 1,
      pageSize: 50000,
    },
    sort: {
      field: '',
      direction: 1,
    },
    filters: buildSummaryFilters(input),
  };

  return params;
};
